import React, { useState, useContext } from 'react'
import axios from 'axios'
import { RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { setAuth } from '../store/actions/auth'

import { Avatar, Button, TextField, Typography } from '@material-ui/core'

import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Admin } from '../types/Admin'
import ConfigContext from '../ConfigContext'

const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}))

const Login: React.FC<RouteComponentProps & ReturnType<typeof mapDispatchToProps>> = ({
  history,
  setAuth
}) => {
  const classes = useStyles({})
  const [adminId, setAdminId] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const config = useContext(ConfigContext)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault()
      const { data } = await axios.post<{
        token: string
        admin: Admin
        message: string
      }>(`/auth/admin/login`, {
        admin_id: adminId,
        password: password
      })
      console.log(data)
      setAuth(
        Number(data.admin.id),
        data.token,
        data.admin.admin_id,
        data.admin.password,
        data.admin.name
      )
      history.push(`/`)
    } catch (error) {
      if (error.response.data.message === 'jwtの期限が切れています。') {
        alert('jwtの期限が切れています')
        return
      } else if (error.response.data.message === '不正なjwtです。') {
        alert('不正なjwtです')
        return
      } else if (
        error.response.data.message ===
        'アクセスが拒否されました。許可されたIPアドレスからのみアクセス可能です。'
      ) {
        alert('アクセスが拒否されました。許可されたIPアドレスからのみアクセス可能です。')
        return
      } else {
        alert('ユーザーID、もしくはパスワードが違います。')
      }
    }
  }

  return (
    <React.Fragment>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {config.loginText1}
        </Typography>
        <Typography component="h1" variant="h5">
          {config.loginText2}
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            value={adminId}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="ユーザー名"
            autoFocus
            onChange={event => setAdminId(event.target.value)}
          />
          <TextField
            value={password}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="パスワード"
            type="password"
            onChange={event => setPassword(event.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            ログイン
          </Button>
        </form>
      </div>
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setAuth: (id: number, token: string, adminId: string, password: string, name: string) =>
      dispatch(setAuth(id, token, adminId, password, name))
  }
}
export default connect(null, mapDispatchToProps)(Login)
// export default Login
